import type { Role } from '../api/types';

/**
 * L'interface est en anglais, la base garde ses valeurs françaises. Quatre
 * écrans exposaient `collaborateur` / `encadrement` / `admin` tels quels : le
 * sélecteur d'accès du back-office, le badge de la fiche nominative, le message
 * de page réservée et l'infobulle de l'en-tête. Ils passent tous par ici.
 *
 * `Connexion.tsx` reste l'exception assumée : c'est le sélecteur d'identité du
 * mode développement, où les valeurs brutes sont ce qu'on veut lire.
 *
 * Ces libellés ne disent rien de la hiérarchie ni du pilotage : « Manager » est
 * un droit d'accès, pas une position dans l'organisation.
 */
const LIBELLES: Record<Role, string> = {
  collaborateur: 'User',
  encadrement: 'Manager',
  admin: 'Admin',
};

export function libelleRole(role: Role): string {
  return LIBELLES[role];
}

export const ROLES: readonly Role[] = ['collaborateur', 'encadrement', 'admin'];
